module.exports = __webpack_public_path__ + "static/social-card-ec1812b31f64e83c82bf3204f0dcf662.jpg";